import React, { Component } from 'react';
import AddSubMilestoneModal from '../components/AddSubMilestoneModal';
import { WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Typography, Button } from '@material-ui/core';

import ListItem from '@material-ui/core/ListItem';
import Paper from '@material-ui/core/Paper';
import {  MyPATLink} from '../../common';
import NoContent from './NoContent';
import WithContent from './WithContent';
import MoreVertModals from '../components/more_vertModal';
import MoreVertModalss from '../components/more_vertModalss';
import BackIcon from '@material-ui/icons/KeyboardBackspace';
import MilestonePageCard from  "../components/MilestoneDetails/MilestonePageCard" 
import MilestoneDetailContent from "../components/MilestoneDetails/MilestoneDetails"
import _ from 'lodash';
import { connect } from 'react-redux';
import courseService from '../services/courseService';
import commentService  from '../services/commentService'
import CourseCommentDialog from '../components/CourseCommentDialog';
import {styles} from '../styling/MilestoneDetails'
import { CourseBasicInfo } from '../modals/CourseBasicInfo';
import { MilestoneDetailData ,MilestoneDetailDefaultData} from '../modals/MilestoneDetails';
import ResponseBasedACL from '../../acl/components/ResponseBasedACL';

interface MilestoneDetailProps extends WithStyles<typeof styles> {
	courseData:CourseBasicInfo;
	match:any;
	history: any;
}

interface MilestoneDetailStates {
	hasContent: Boolean,
	addSubMilestoneOpen:Boolean,
	milestoneArr:MilestoneDetailData,
	isCommentDialogOpen:Boolean,
	commentCount : any,
	userId:string
}
let count:any = 0;
let test:any;
class MilestoneDetails extends Component<MilestoneDetailProps, MilestoneDetailStates> {
	constructor(props: MilestoneDetailProps) {
		super(props);
		let that = this;
		this.state = {
			hasContent: true,
			addSubMilestoneOpen:false,
			milestoneArr:MilestoneDetailDefaultData,
			isCommentDialogOpen:false,
			commentCount:commentService.getComments("all",this.props.match.params.courseID),
			userId : JSON.parse(`${localStorage.getItem('patmy')}`).authenticatedUser.id
		};
		this.openSubMilestoneHandler = this.openSubMilestoneHandler.bind(this);
		this.openSubMilestoneCloseHandler = this.openSubMilestoneCloseHandler.bind(this);
		this.state.commentCount.then(function(data:any){
			if(data.length>0){
			data.forEach(function(ele:any){
					if(!ele.readBy.includes(that.state.userId)){
						count++;
					}
				})
			}
		})
	}

	openSubMilestoneHandler = () => {
		this.setState({
			addSubMilestoneOpen: true
		})
	}

	openSubMilestoneCloseHandler() {
		this.setState({
			addSubMilestoneOpen: false
		})
	}
	
	
  handleCommentDialogClose(){
		this.setState({
			isCommentDialogOpen:false
		})
	}

	componentWillMount() {
		this.loadMilestoneDetails();
	}

	loadMilestoneDetails(){
		courseService.getMilestoneDetail(this.props.match.params.courseID,this.props.match.params.milestoneId).then((milestoneArr:any) => {
			var self = this;
			 self.setState({milestoneArr:milestoneArr})
				});
	}
	render() {
		let { classes ,courseData,} = this.props;
		if (_.isEmpty(courseData)) {
			courseData = JSON.parse(localStorage.getItem("myPatCourse") || "")
		}
		if (_.isEmpty(courseData)) {
			return ""
		}
		const { hasContent ,addSubMilestoneOpen,milestoneArr,isCommentDialogOpen} = this.state;
		const Content = hasContent ? <WithContent /> : <NoContent />;
		var courseID = (window.location.href)
		courseID = courseID.substring(courseID.lastIndexOf("/"),courseID.length);

		return (
			<>
				<Grid container
					spacing={0}
					direction="column"
					className={classes.root}>
					<Grid item xs={12} className={classes.wrapperMain}>

						<Grid xs={12}
							container
							direction="row"
							alignContent="center"
							justify="space-between"
						>
							<Grid xs={5}>
								<MyPATLink onClick={() => this.props.history.goBack()} to="/">
									<Typography variant="h6" style={{ padding: "10px" ,color:"#000000"}}>
										<BackIcon /> Course Plan  {milestoneArr.milestoneBasicDetail?milestoneArr.milestoneBasicDetail.name:""}&nbsp;&nbsp;
										<img src="/assets/img/course/chevron.png" alt="chevron"/>
									</Typography>
								</MyPATLink>
							</Grid>
							<Grid xs={5} container justify="flex-end" alignItems="flex-end">
								<ResponseBasedACL
									response={_.get(courseData, 'aclMetaData', {})}
									responseKey='allowedTo'
									accessType={['EDIT']}
								>
									<Button
										variant="contained"
										type="submit"
										color="primary"
										// disabled= {courseData?true:false}
										onClick={()=>this.setState({addSubMilestoneOpen:true})}
										style={{ marginLeft: "45px" }}
									>
										Add Sub Milestones
								</Button>
							   </ResponseBasedACL>
							   <Grid xs={1} container justify="flex-end" alignItems="flex-end">
							   {
								   count >  0 ? 
								   <div className={classes.circle}>{count}</div> 
								   : ''
								}
							   <img onClick={()=>this.setState({isCommentDialogOpen:true})} style={{width:"30px",height:"30px",marginLeft:"135px"}} src="/assets/img/mylibrary/big-speech-balloon.png" alt="comments" />
							   </Grid>
							   <ResponseBasedACL
									response={_.get(courseData, 'aclMetaData', {})}
									responseKey='allowedTo'
									accessType={['EDIT']}
								>
							  		<Grid  style={{marginLeft:"75px"}} item xs={1} className={classes.vertHeaderActions}>
										<MoreVertModalss />
									</Grid>
								</ResponseBasedACL>
							</Grid>
							
						
						</Grid>
						<div key={1}>
							<Paper elevation={0} style={{ marginBottom: 10 }}>
								<ListItem>
									<MilestonePageCard  cardDetails={milestoneArr.milestoneBasicDetail} />
								</ListItem>
							</Paper>
						</div>
					</Grid>
				</Grid>
				<MilestoneDetailContent milestoneArr={milestoneArr} courseDetails={courseData} refreshMilestone={() => { this.loadMilestoneDetails() }}/>
				<AddSubMilestoneModal 
							addSubMilestoneOpen={addSubMilestoneOpen}
							addSubMilestoneCloseHandler={this.openSubMilestoneCloseHandler}
							milestoneData={courseData.milestones || []}
							courseID={this.props.match.params.courseID}
							currentMilestone={milestoneArr.milestoneBasicDetail}
							startDate={_.get(milestoneArr, 'milestoneBasicDetail.startDate')}
						/>
				{isCommentDialogOpen &&
					<CourseCommentDialog
						isDialogOpen={isCommentDialogOpen}
						dialogCloseHandler={this.handleCommentDialogClose.bind(this)}
						courseID={this.props.match.params.courseID}
					/>}
			</>
		)
	}
}

const mapStateToProps = (state:any) => ({
	courseData: state.courseData.courseData.list
});


// @ts-ignore
export default connect(mapStateToProps, null)(withStyles(styles)(MilestoneDetails));
